import { Material } from "./material.model";

export class LearningObject {
  constructor(
    public learningGroupType: LearningGroupType = LearningGroupType.INTRODUCTION,
    public id: string = "",
    public name: string = "",
    public materials: Material[] = []
  ) {}
}
export class LearningGroupType {
    public static readonly INTRODUCTION = "INTRODUCTION";
    public static readonly CLOSURE = "CLOSURE";
    public static readonly DEVELOPMENT = "DEVELOPMENT";
    public static readonly MOTIVATION = "MOTIVATION";
  }
